import React from 'react';
import Button from './button/index';
import useLogo from '../hooks/use-logo';
import Image from './image';

const Logo = ({ image, className, ...props }) => {
  const defaultLogo = useLogo();
  const logo = image || defaultLogo;

  if (!logo) {
    return null;
  }

  return (
    <Button wrapper to="/" aria-label="Terug naar de homepage">
      <Image
        className={className}
        image={logo}
        {...props}
      />
    </Button>
  );
};

export default Logo;
